module.exports = __webpack_public_path__ + "803cb6ddd25348c3f73123a4bdf2f304.png";